import {Button, Divider} from '@mui/material'
import {asSubmitData} from 'pages/install/dataConfig/submitData'
import markerImage from 'pages/install/images/maker.png'
import AsInstallModalContainer from 'pages/install/modules/asModalComponents/AsInstallModalContainer'
import {useRef, useState} from 'react'
import {Map, MapMarker, MapTypeControl} from 'react-kakao-maps-sdk'
import {useSelector} from 'react-redux'
import {loadSignalConfig} from 'utils/config/signalConfig'

const AsInstall = (props: any) => {
  const {countCall, getPosition} = props
  const position = useSelector((state: any) => state?.currentPosition.position)
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const [asInstallSubmit, setAsInstallSubmit] = useState<any>(asSubmitData)
  const mapRef = useRef<any>(null)
  const [renderStep, setRenderStep] = useState<number>(0)
  const clear = () => {
    setRenderStep(0)
    setAsInstallSubmit(asSubmitData)
  }

  const [modalStatus, setModalStatus] = useState<boolean>(false)
  /* 판정 기준은 렌더 중 동기로 읽히므로, 설정이 늦게 도착하면 화면 갱신을 한 번 더 유도한다 */
  const [, refreshSignalConfigView] = useState<number>(0)
  const modalOpen = () => {
    // getPosition()
    setAsInstallSubmit((prev: any) => ({
      ...prev,
      latitude: position?.latitude,
      longitude: position?.longitude,
      updateId: userInfo?.userId,
    }))

    setModalStatus(true)
    /* 최신 판정 기준을 다시 받아온다. 모달은 기다리지 않고 바로 열고,
       도착하면 그때 다시 그린다. (실패해도 직전 기준으로 계속 동작) */
    loadSignalConfig().then(() => refreshSignalConfigView((v) => v + 1))
  }
  const modalClose = () => setModalStatus(false)

  return (
    <div className={'container-fluid w-100 px-0 mb-5'}>
      <div className={'card card-body '}>
        <span className={'fw-bolder fs-3'}>현재위치</span>
        <Map
          id='map'
          center={{
            lat: position?.latitude,
            lng: position?.longitude,
          }}
          onCreate={(map: any) => (mapRef.current = map)}
          isPanto={false}
          style={{
            width: '100%',
            height: 'clamp(250px, 60dvh, 380px)',
          }}
          level={3}
          mapTypeId={kakao.maps.MapTypeId.ROADMAP}
          className={' mt-2 rounded'}
        >
          <MapTypeControl position={kakao.maps.ControlPosition.TOPRIGHT} />
          <MapMarker
            position={{
              lat: position?.latitude,

              lng: position?.longitude,
            }}
            draggable={false}
            image={{src: markerImage, size: {width: 30, height: 45}}}
          />
        </Map>
        <Divider className={'my-3 '} color={'#919090'} />
        <Button variant='contained' color='warning' className={'float-end'} onClick={modalOpen}>
          A/S 진행하기
        </Button>
      </div>
      <AsInstallModalContainer
        open={modalStatus}
        onClose={modalClose}
        name={'as-modal-container'}
        renderStep={renderStep}
        set={setAsInstallSubmit}
        clear={clear}
        countCall={countCall}
        asSubmit={asInstallSubmit}
        setRenderStep={setRenderStep}
        getPosition={getPosition}
      />
    </div>
  )
}

export default AsInstall
